<app-basic-info-components
  actionType="{{ guidelineComponent?.activityType }}"
  code="{{ guidelineComponent?.code }}"
  publishDate="{{ guidelineComponent?.publishDate }}"
  version="{{ guidelineComponent?.version }}"
  [codings]="guidelineComponent?.codings" />
